var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"graphtosvgcontainer",staticStyle:{"position":"fixed","height":"100%","width":"100%","z-index":"9999","background-color":"white"},on:{"click":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }